var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDifficultyIntermediate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 29,
    viewBox: "0 0 47 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.289 9.79804C28.544 9.36704 27.629 9.36404 26.884 9.79004L17.726 15.023C16.976 15.452 16.512 16.25 16.512 17.115V26.551C16.512 27.882 17.591 28.961 18.922 28.961H28.08C29.411 28.961 30.49 27.882 30.49 26.551V11.883C30.489 11.024 30.031 10.229 29.289 9.79804Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.899 19.1636C12.155 18.7286 11.239 18.7276 10.494 19.1556L1.21501 24.4586C0.266007 24.9996 -0.199993 26.1126 0.0810065 27.1686C0.361006 28.2256 1.31701 28.9606 2.41001 28.9606H11.69C13.021 28.9606 14.1 27.8816 14.1 26.5506V21.2466C14.101 20.3896 13.643 19.5936 12.899 19.1636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5478 0.796114L45.548 0.79622C46.1369 1.13781 46.4997 1.76789 46.4989 2.44814V2.44872V26.5507C46.4989 27.6056 45.6438 28.4607 44.5889 28.4607H35.3099C34.255 28.4607 33.3999 27.6056 33.3999 26.5507V7.75172C33.3999 7.06626 33.7677 6.43291 34.3629 6.09288L34.363 6.09285L43.642 0.790847L43.6425 0.790518C44.2327 0.452248 44.9583 0.453789 45.5478 0.796114Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifficultyIntermediate);
export default __webpack_public_path__ + "static/media/difficultyIntermediate.66d552fb0942184d311144c6d67f68e4.svg";
export { ForwardRef as ReactComponent };